<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="消息来源" prop="from">
          <el-input v-model="form.from"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="主题" prop="subject">
          <el-input v-model="form.subject"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="版本" prop="as2version">
          <el-input v-model="form.as2version"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="请求数据类型" prop="contenttype">
          <el-input v-model="form.contenttype"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>

  import rApi from "@/api/senior/seniorconf";
  let datafault = {
  };
  export default {
    components: { rApi },
    props: {
      uuid:""
    },
    data() {
      return {
        form:{
          from:"ase@ase.cn",
          subject:"ASE_AS2_MESSAGE",
          as2version:"1.2",
          contenttype:"application/XML"
        }
      };
    },
    mounted() {
      if(this.uuid){
        rApi.getPdSenior(this.uuid).then(resp=>{
          var _form = JSON.parse(resp.data);
          this.form.from = _form.from?_form.from:this.form.from;
          this.form.subject = _form.subject?_form.subject:this.form.subject;
          this.form.as2version = _form.as2version?_form.as2version:this.form.as2version;
          this.form.contenttype = _form.contenttype?_form.contenttype:this.form.contenttype;
        });
      }
    },
    methods: {
      save(){
        if(this.uuid){
          rApi.doSaveForPdSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
        }
        return this.form;
      }
    }
  };
</script>
<style scoped>
</style>